'use client';

import { styled } from '../../styles';
import { Typography } from '../Typography';

export const StyledDataGridEmptyState = styled(Typography)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 88,
  margin: theme.spacing(8, 0, 0),
  backgroundColor: theme.palette.surface2,
  color: theme.palette.text3,
  borderRadius: theme.spacing(4),
}));
